export const translations = {
  'pt-BR': {
    nav: {
      login: 'Login',
      language: 'Idioma'
    },
    hero: {
      headline: 'Algo incrível está chegando.',
      subheadline: 'E-Ink Smart Signage revolucionária + Cloud CMS para hotéis, restaurantes e espaços públicos.',
      cta1: 'Quero participar'
    },
    about: {
      title: 'Nossa visão',
      card1Title: 'E-Ink Ultra-Low Power',
      card1Desc: 'Sinalização digital com consumo mínimo de energia usando tecnologia E-Ink de última geração.',
      card2Title: 'Cloud CMS Inteligente',
      card2Desc: 'Gerencie todo o seu conteúdo de qualquer lugar com nossa plataforma na nuvem fácil de usar.',
      card3Title: 'Sustentável por Design',
      card3Desc: 'Menos papel, menos eletricidade, mais sustentabilidade para o seu negócio.'
    },
    jobs: {
      title: 'Junte-se a Nós',
      subtitle: 'Estamos expandindo nossa equipe em São Paulo',
      role1Title: 'Administração / Office',
      role1Location: 'São Paulo, Brasil',
      role1Tasks: 'O que você fará:',
      role1Task1: 'Gerenciamento administrativo e operações do escritório',
      role1Task2: 'Coordenação de processos internos e documentação',
      role1Task3: 'Suporte à equipe de gestão',
      role1Task4: 'Organização de eventos e meetings',
      role1Looking: 'Procuramos:',
      role1Need1: 'Experiência em administração ou gestão de escritório',
      role1Need2: 'Excelentes habilidades organizacionais',
      role1Need3: 'Proficiência em PT-BR e inglês',
      role2Title: 'Sales / Business Development',
      role2Location: 'São Paulo, Brasil',
      role2Tasks: 'O que você fará:',
      role2Task1: 'Identificar e desenvolver novos clientes no setor hoteleiro e F&B',
      role2Task2: 'Apresentar nossa solução Smart Signage',
      role2Task3: 'Construir relacionamentos de longo prazo com clientes',
      role2Task4: 'Negociação de contratos e fechamento de vendas',
      role2Looking: 'Procuramos:',
      role2Need1: 'Experiência comprovada em vendas B2B',
      role2Need2: 'Excelente comunicação e networking',
      role2Need3: 'Conhecimento do mercado local em São Paulo'
    },
    form: {
      title: 'Quero participar',
      subtitle: 'Preencha o formulário e nos conte por que você é perfeito para nós.',
      name: 'Nome Completo',
      namePlaceholder: 'Seu nome',
      email: 'E-mail',
      emailPlaceholder: 'seu@email.com',
      whatsapp: 'WhatsApp (opcional)',
      whatsappPlaceholder: '+55 11 99999-9999',
      location: 'Cidade / País',
      locationPlaceholder: 'São Paulo, Brasil',
      interest: 'Meu interesse é como:',
      interestOptions: {
        admin: 'Admin / Office',
        sales: 'Sales / Business Development',
        partner: 'Parceiro',
        customer: 'Cliente',
        investor: 'Investidor',
        other: 'Outro'
      },
      why: 'Por que você é importante/bom para nós?',
      whyPlaceholder: 'Conte-nos sobre sua experiência, habilidades e por que você se encaixa bem...',
      linkedin: 'LinkedIn URL (opcional)',
      linkedinPlaceholder: 'https://linkedin.com/in/seu-perfil',
      privacy: 'Eu aceito a política de privacidade',
      submit: 'Quero participar',
      success: 'Obrigado! Entramos em contato em breve e ficamos em contato!',
      error: 'Algo deu errado. Por favor, tente novamente.'
    },
    footer: {
      tagline: 'Transformando sinalização digital com tecnologia sustentável.',
      company: 'Empresa',
      about: 'Sobre Nós',
      careers: 'Carreiras',
      contact: 'Contato',
      legal: 'Legal',
      privacy: 'Privacidade',
      terms: 'Termos',
      imprint: 'Impressum',
      rights: '© 2025 smart-signage.com.br. Todos os direitos reservados.'
    },
    login: {
      title: 'Admin Login',
      subtitle: 'Acesse o painel de administração',
      email: 'E-mail',
      emailPlaceholder: 'admin@smart-signage.com.br',
      password: 'Senha',
      passwordPlaceholder: 'Sua senha',
      submit: 'Entrar',
      error: 'E-mail ou senha incorretos',
      backToHome: 'Voltar para Home'
    },
    admin: {
      title: 'Leads Dashboard',
      logout: 'Sair',
      search: 'Buscar...',
      filter: 'Filtrar por:',
      filterAll: 'Todos',
      exportCSV: 'Exportar CSV',
      name: 'Nome',
      email: 'E-mail',
      interest: 'Interesse',
      location: 'Localização',
      date: 'Data',
      actions: 'Ações',
      view: 'Ver',
      delete: 'Excluir',
      total: 'Total de Leads',
      noLeads: 'Nenhum lead encontrado'
    }
  },
  'en': {
    nav: {
      login: 'Login',
      language: 'Language'
    },
    hero: {
      headline: 'Something breathtaking is coming.',
      subheadline: 'Revolutionary E-Ink Smart Signage + Cloud CMS for hotels, restaurants, and public spaces.',
      cta1: 'I want in'
    },
    about: {
      title: 'Our vision',
      card1Title: 'Ultra-Low Power E-Ink',
      card1Desc: 'Digital signage with minimal power consumption using cutting-edge E-Ink technology.',
      card2Title: 'Smart Cloud CMS',
      card2Desc: 'Manage all your content from anywhere with our easy-to-use cloud platform.',
      card3Title: 'Sustainable by Design',
      card3Desc: 'Less paper, less electricity, more sustainability for your business.'
    },
    jobs: {
      title: 'Join Us',
      subtitle: 'We are expanding our team in São Paulo',
      role1Title: 'Administration / Office',
      role1Location: 'São Paulo, Brazil',
      role1Tasks: 'What you will do:',
      role1Task1: 'Administrative management and office operations',
      role1Task2: 'Coordination of internal processes and documentation',
      role1Task3: 'Support for management team',
      role1Task4: 'Organization of events and meetings',
      role1Looking: 'We are looking for:',
      role1Need1: 'Experience in administration or office management',
      role1Need2: 'Excellent organizational skills',
      role1Need3: 'Proficiency in PT-BR and English',
      role2Title: 'Sales / Business Development',
      role2Location: 'São Paulo, Brazil',
      role2Tasks: 'What you will do:',
      role2Task1: 'Identify and develop new clients in hospitality and F&B sector',
      role2Task2: 'Present our Smart Signage solution',
      role2Task3: 'Build long-term relationships with clients',
      role2Task4: 'Contract negotiation and closing sales',
      role2Looking: 'We are looking for:',
      role2Need1: 'Proven experience in B2B sales',
      role2Need2: 'Excellent communication and networking',
      role2Need3: 'Knowledge of the local São Paulo market'
    },
    form: {
      title: 'I want in',
      subtitle: 'Fill out the form and tell us why you are perfect for us.',
      name: 'Full Name',
      namePlaceholder: 'Your name',
      email: 'E-mail',
      emailPlaceholder: 'your@email.com',
      whatsapp: 'WhatsApp (optional)',
      whatsappPlaceholder: '+55 11 99999-9999',
      location: 'City / Country',
      locationPlaceholder: 'São Paulo, Brazil',
      interest: 'I am interested as:',
      interestOptions: {
        admin: 'Admin / Office',
        sales: 'Sales / Business Development',
        partner: 'Partner',
        customer: 'Customer',
        investor: 'Investor',
        other: 'Other'
      },
      why: 'Why are you important/good for us?',
      whyPlaceholder: 'Tell us about your experience, skills, and why you are a good fit...',
      linkedin: 'LinkedIn URL (optional)',
      linkedinPlaceholder: 'https://linkedin.com/in/your-profile',
      privacy: 'I accept the privacy policy',
      submit: 'I want in',
      success: 'Thank you! We will stay in touch and get back to you!',
      error: 'Something went wrong. Please try again.'
    },
    footer: {
      tagline: 'Transforming digital signage with sustainable technology.',
      company: 'Company',
      about: 'About Us',
      careers: 'Careers',
      contact: 'Contact',
      legal: 'Legal',
      privacy: 'Privacy',
      terms: 'Terms',
      imprint: 'Imprint',
      rights: '© 2025 smart-signage.com.br. All rights reserved.'
    },
    login: {
      title: 'Admin Login',
      subtitle: 'Access the administration panel',
      email: 'E-mail',
      emailPlaceholder: 'admin@smart-signage.com.br',
      password: 'Password',
      passwordPlaceholder: 'Your password',
      submit: 'Sign In',
      error: 'Incorrect email or password',
      backToHome: 'Back to Home'
    },
    admin: {
      title: 'Leads Dashboard',
      logout: 'Logout',
      search: 'Search...',
      filter: 'Filter by:',
      filterAll: 'All',
      exportCSV: 'Export CSV',
      name: 'Name',
      email: 'E-mail',
      interest: 'Interest',
      location: 'Location',
      date: 'Date',
      actions: 'Actions',
      view: 'View',
      delete: 'Delete',
      total: 'Total Leads',
      noLeads: 'No leads found'
    }
  },
  'de': {
    nav: {
      login: 'Login',
      language: 'Sprache'
    },
    hero: {
      headline: 'Hier entsteht etwas Atemberaubendes.',
      subheadline: 'Revolutionäre E-Ink Smart Signage + Cloud CMS für Hotels, Restaurants und öffentliche Räume.',
      cta1: 'Ich will dabei sein'
    },
    about: {
      title: 'Unsere Vision',
      card1Title: 'Ultra-Low Power E-Ink',
      card1Desc: 'Digitale Beschilderung mit minimalem Stromverbrauch durch modernste E-Ink-Technologie.',
      card2Title: 'Smart Cloud CMS',
      card2Desc: 'Verwalten Sie alle Ihre Inhalte von überall mit unserer benutzerfreundlichen Cloud-Plattform.',
      card3Title: 'Nachhaltig im Design',
      card3Desc: 'Weniger Papier, weniger Strom, mehr Nachhaltigkeit für Ihr Unternehmen.'
    },
    jobs: {
      title: 'Werde Teil des Teams',
      subtitle: 'Wir erweitern unser Team in São Paulo',
      role1Title: 'Administration / Office',
      role1Location: 'São Paulo, Brasilien',
      role1Tasks: 'Was Sie tun werden:',
      role1Task1: 'Verwaltungsmanagement und Bürobetrieb',
      role1Task2: 'Koordination interner Prozesse und Dokumentation',
      role1Task3: 'Unterstützung des Managementteams',
      role1Task4: 'Organisation von Veranstaltungen und Meetings',
      role1Looking: 'Wir suchen:',
      role1Need1: 'Erfahrung in Verwaltung oder Büromanagement',
      role1Need2: 'Ausgezeichnete organisatorische Fähigkeiten',
      role1Need3: 'Kenntnisse in PT-BR und Englisch',
      role2Title: 'Sales / Business Development',
      role2Location: 'São Paulo, Brasilien',
      role2Tasks: 'Was Sie tun werden:',
      role2Task1: 'Identifizierung und Entwicklung neuer Kunden im Gastgewerbe und F&B',
      role2Task2: 'Präsentation unserer Smart Signage Lösung',
      role2Task3: 'Aufbau langfristiger Kundenbeziehungen',
      role2Task4: 'Vertragsverhandlung und Verkaufsabschluss',
      role2Looking: 'Wir suchen:',
      role2Need1: 'Nachgewiesene Erfahrung im B2B-Vertrieb',
      role2Need2: 'Exzellente Kommunikation und Networking',
      role2Need3: 'Kenntnis des lokalen Marktes in São Paulo'
    },
    form: {
      title: 'Ich will dabei sein',
      subtitle: 'Füllen Sie das Formular aus und sagen Sie uns, warum Sie perfekt für uns sind.',
      name: 'Vollständiger Name',
      namePlaceholder: 'Ihr Name',
      email: 'E-Mail',
      emailPlaceholder: 'ihre@email.com',
      whatsapp: 'WhatsApp (optional)',
      whatsappPlaceholder: '+55 11 99999-9999',
      location: 'Stadt / Land',
      locationPlaceholder: 'São Paulo, Brasilien',
      interest: 'Ich interessiere mich als:',
      interestOptions: {
        admin: 'Admin / Office',
        sales: 'Sales / Business Development',
        partner: 'Partner',
        customer: 'Kunde',
        investor: 'Investor',
        other: 'Sonstiges'
      },
      why: 'Warum sind Sie wichtig/gut für uns?',
      whyPlaceholder: 'Erzählen Sie uns von Ihrer Erfahrung, Ihren Fähigkeiten und warum Sie gut passen...',
      linkedin: 'LinkedIn URL (optional)',
      linkedinPlaceholder: 'https://linkedin.com/in/ihr-profil',
      privacy: 'Ich akzeptiere die Datenschutzerklärung',
      submit: 'Ich will dabei sein',
      success: 'Danke! Wir bleiben in Kontakt und melden uns bei Dir!',
      error: 'Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.'
    },
    footer: {
      tagline: 'Digitale Beschilderung mit nachhaltiger Technologie transformieren.',
      company: 'Unternehmen',
      about: 'Über Uns',
      careers: 'Karriere',
      contact: 'Kontakt',
      legal: 'Rechtliches',
      privacy: 'Datenschutz',
      terms: 'AGB',
      imprint: 'Impressum',
      rights: '© 2025 smart-signage.com.br. Alle Rechte vorbehalten.'
    },
    login: {
      title: 'Admin Login',
      subtitle: 'Zugang zum Verwaltungspanel',
      email: 'E-Mail',
      emailPlaceholder: 'admin@smart-signage.com.br',
      password: 'Passwort',
      passwordPlaceholder: 'Ihr Passwort',
      submit: 'Anmelden',
      error: 'Falsche E-Mail oder Passwort',
      backToHome: 'Zurück zur Startseite'
    },
    admin: {
      title: 'Leads Dashboard',
      logout: 'Abmelden',
      search: 'Suchen...',
      filter: 'Filtern nach:',
      filterAll: 'Alle',
      exportCSV: 'CSV Exportieren',
      name: 'Name',
      email: 'E-Mail',
      interest: 'Interesse',
      location: 'Standort',
      date: 'Datum',
      actions: 'Aktionen',
      view: 'Ansehen',
      delete: 'Löschen',
      total: 'Gesamte Leads',
      noLeads: 'Keine Leads gefunden'
    }
  }
};